import { formatPrice } from '@helpers/payment'
import styles from '@pages/Checkout/routes/components/PurchaseSummaryPanel/PurchaseSummaryPanel.module.scss'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { Paragraph, Spreader, Text } from '@ui-kit'
import { useTranslation } from 'react-i18next'

export const PromotionForFreePlanPrice = ({
  planPricePerMonth,
  basicPrice
}: {
  planPricePerMonth: number
  basicPrice: number
}) => {
  const { t } = useTranslation()

  const { accountCurrency } = useCheckoutContext()

  return (
    <Paragraph align='right'>
      <Text
        tag='span'
        color='neutral-6'
        className={styles['summary-panel--line-through']}
      >
        ({formatPrice(basicPrice)})
      </Text>
      <Spreader spread={5} />
      {formatPrice(planPricePerMonth)} {accountCurrency}{' '}
      {t('checkout.configure.purchase.summary.monthly', {
        net: accountCurrency === 'PLN' ? t('word.net') : ''
      })}
    </Paragraph>
  )
}
